import {Injectable} from '@angular/core';
import {HttpClient, HttpContext, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {MvsCrudService} from 'features/core/shared/service/crud/mvs-crud.service';
import {CpAgentStatementResult} from '../../interface/cp-agent-statement-result.interface';
import {SUPPRESS_ERROR_HANDLER} from 'features/core/shared/service/crud/suppress-error-token';
import {CpStatementReissueRequest} from '../../interface/cp-statement-reissue-request.interface';
import {cpDownloadBlobWithServerName$} from '../domain/cp-file-download';

/**
 * Service of cp.ProvisionAgentStatement (Provisionsabrechnung). Read/list is the standard CRUD;
 * the backend refuses generic create/update/delete — statements are created via
 * `CpProvisionRunService#createAgentStatement$` / `#createAgentStatements$` and replaced by
 * {@link reissue$}.
 */
@Injectable({
    providedIn: 'root'
})
export class CpProvisionAgentStatementService extends MvsCrudService {

    constructor(protected override http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/cp/provisionAgentStatements');
    }

    /**
     * POST /{id}/reissue — replaces a final statement with a new version (new number); the old one
     * becomes SUPERSEDED and stays in dm. The reason is mandatory (max. 500 characters). A refusal
     * (400/403/404/409) carries the German text in `error.data` — see `cpServerMessage`; the global
     * error toast is suppressed, the caller reports.
     */
    public reissue$(statementId: number, reason: string): Observable<CpAgentStatementResult> {
        const body: CpStatementReissueRequest = {reason};
        return this.http.post<CpAgentStatementResult>(this.apiUrl + `/${statementId}/reissue`, body,
            {context: new HttpContext().set(SUPPRESS_ERROR_HANDLER, true)});
    }

    /**
     * GET /{id}/document — downloads the stored PDF of the statement (filename from
     * Content-Disposition, `Provisionsabrechnung-{id}.pdf` as fallback).
     */
    public downloadDocument$(statementId: number): Observable<Blob> {
        return cpDownloadBlobWithServerName$(this.http, 'GET', this.apiUrl + `/${statementId}/document`,
            new HttpParams(), `Provisionsabrechnung-${statementId}.pdf`, true).pipe(map(response => response.body as Blob));
    }
}
